import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useNetSalesReportV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.netSalesReportV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getNetSalesReportV2(), {
        params,
      });

      const composeResponse = {
        providerNetSales: res.data.data.report.provider_net_sales_report,
        clinicNetSales: res.data.data.report.clinic_net_sales_report,
      };
      return composeResponse;
    },
    options,
  );
};
